import { RQ } from 'utils';

export default {
  test: function (func) {
    let that = this;
    switch (func) {
      case 'CAN_I_USE': {
        window.ReactNativeBridge.call('CAN_I_USE', {
          name: 'CAN_I_USE',
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      };
      case 'SET_STATUS_BAR': {
        window.ReactNativeBridge.call('SET_STATUS_BAR', {
          bgColor: '#ff5775',
          theme: 'custom', // oneOf(['white', 'black', 'transparent', 'gray', 'custom'])
          statusBarTheme: 'light-content', // 'default' : 'light-content'
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'SET_HEADER': {
        window.ReactNativeBridge.call('SET_HEADER', {
          title: '这是\(^o^)/~h5修改的标题',
          rightContent: {
            type: 'text',
            content: '编辑'
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      };
      case 'KEYBOARD': {
        window.ReactNativeBridge.call('KEYBOARD', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      };
      case 'CLIPBOARD': {
        window.ReactNativeBridge.call('CLIPBOARD', {
          text: '老大很强',
          success: (res) => {
            console.log(res)
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'DEVICE_INFO': {
        window.ReactNativeBridge.call('DEVICE_INFO', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'VIBRATION': {
        window.ReactNativeBridge.call('VIBRATION', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'APP_INFO': {
        window.ReactNativeBridge.call('APP_INFO', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'CAMERA': {
        window.ReactNativeBridge.call('CAMERA', {
          showSheet: true,
          btnsArr: [{
            text: '从相册中选择1',
            type: 'openCamera'
          }, {
            text: '拍照1',
            type: 'openPicker'
          }
          ],
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'IMAGE': {
        window.ReactNativeBridge.call('IMAGE', {
          imgs: ['https://201442.image.myqcloud.com/201442/0/cb3af621-864c-4430-a792-e450f662a3f8/original',
            'http://201442.image.myqcloud.com/201442/0/8b62bfce-9930-4560-9f97-53beefda9061/original'],
          index: 0,
          type: 2, // 1(默认)-查看大图,2-下载图片
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'APP_STATE': {
        window.ReactNativeBridge.call('APP_STATE', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }

      case 'BUY': {
        window.ReactNativeBridge.call('BUY', {
          goodsInfoId: 10544,
          goodsNum: 1,
          // specialId: '', // 可不传
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'ADD_TO_FAVORITE': {
        window.ReactNativeBridge.call('ADD_TO_FAVORITE', {
          goodsId: 10544,
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'ADD_TO_CART': {
        window.ReactNativeBridge.call('ADD_TO_CART', {
          goodsId: 10544,
          goodsInfoId: 1,
          goodsNum: 1,
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'SET_SHARE': {
        window.ReactNativeBridge.call('SET_SHARE', {
          shareData: {},
          shareWay: ['session', 'timeline', 'wxapp', 'qq', 'weibo', 'links'], // one of ['session', 'timeline', 'wxapp', 'qq', 'weibo', 'links']
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        })
        return;
      }
      case 'NAVIGATION': {
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'GoodsList',
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'GET_USER_INFO': {
        window.ReactNativeBridge.call('GET_USER_INFO', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'GET_BUSINESS_INFO': {
        window.ReactNativeBridge.call('GET_BUSINESS_INFO', {
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'TOAST': {
        window.ReactNativeBridge.call('TOAST', {
          text: 'h5调用的toast',
          method: 'showShortCenter', // one of ['show', 'hide', 'showShortTop', 'showShortCenter'(default), 'showShortBottom', 'showLongTop', 'showLongCenter', 'showLongBottom']
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'ALERT': {
        window.ReactNativeBridge.call('ALERT', {
          title: '弹窗测试',
          content: '老大666',
          btnsArr: [
						{text: '取消1', color: '#666', onPress: () => { console.log('--------this', this) }},
						{text: '去开通1', color: '#ff5775', onPress: () => { console.log('--------this', this) }}
          ],
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        return;
      }
      case 'POPUP': {
        window.ReactNativeBridge.call('POPUP', {
          title: '弹窗测试',
          content: '老大666',
          btnsArr: [
						{text: '取消1', color: '#666', onPress: () => { console.log('--------this', this) }},
						{text: '去开通1', color: '#ff5775', onPress: () => { console.log('--------this', this) }}
          ],
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
      }
    }
  },

  test1: function () {
    console.log('window.ReactNativeBridge', window, window.ReactNativeBridge)
    window.ReactNativeBridge.call('myFunctionName', {
      arg1: 'arg1',
      arg2: 'arg2',
      success: (res) => {
        console.log(res)
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test2: function () {
    // window.ReactNativeBridge.call('SET_HEADER', {
		// 	title: '这是\(^o^)/~h5修改的标题',
		// 	rightContent: {
		// 		type: 'text',
		// 		content: '编辑'
		// 	},
		// 	success: (res) => {
		// 		console.log(res);
		// 	},
		// 	fail: (err) => {
    //     console.error(err)
    //   }
		// });
    console.log('-----------test2', this)
    this.RNToast.showShortCenter('h5调用的toast')
  },
  test10: function () {
    window.ReactNativeBridge.call('ADD_TO_CART', {
      goodsId: 10544,
      goodsInfoId: 1,
      goodsNum: 1,
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test9: function () {
    window.ReactNativeBridge.call('ADD_TO_FAVORITE', {
      goodsId: 10544,
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test8: function () {
    window.ReactNativeBridge.call('ALERT', {
      title: '弹窗测试',
      content: '为什么这里可以渲染界面',
      btnsArr: [
				{text: '取消1', color: '#666', onPress: () => { console.log('--------this', this) }},
				{text: '去开通1', color: '#ff5775', onPress: () => { console.log('--------this', this) }}
      ],
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test7: function () {
    window.ReactNativeBridge.call('BUY', {
      goodsId: '11572',
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test6: function () {
    window.ReactNativeBridge.call('NAVIGATION', {
      id: 'GoodsList',
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test5: function () {
    window.ReactNativeBridge.call('CAN_I_USE', {
      name: 'CAN_I_USE',
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test3: function () {
    window.ReactNativeBridge.call('TOAST', {
      text: 'h5调用的toast',
      success: (res) => {
        console.log(res);
      },
      fail: (err) => {
        console.error(err)
      }
    });
  },
  test4: function () {
    window.ReactNativeBridge.call('CLIPBOARD', {
      text: '老大很强',
      success: (res) => {
        console.log(res)
      },
      fail: (err) => {
        console.error(err)
      }
    });
  }
};
//
// sdk.myFunctionName({
//   arg1: 'arg1',
//   arg2: 'arg2',
//   success: (res)=> {
//     console.log(res)
//   },
//   fail: (err) => {
//     console.error(err)
//   }
// })



// WEBPACK FOOTER //
// ./src/module/app/jsBridge/action.js